import { ChangeDetectionStrategy, Component, input, output } from "@angular/core";

import { LktIconComponent } from "../icon/icon.component";

import { ViewSwitchSegment } from "./view-switch.type";

/**
 * Alternador segmentado vertical entre os sistemas (Administração ⇄ Plataforma),
 * replicando o `.viewswitch` do protótipo lekto-v3.
 *
 * O segmento ativo (`activeId`) representa o sistema atual e não dispara evento;
 * clicar em outro segmento emite `segmentClick` com o `id` do destino, cabendo ao
 * consumidor decidir a navegação cross-app.
 *
 * Em `collapsed` (rail icon-only) o rótulo vira tooltip no hover; expandido, o
 * rótulo aparece ao lado do ícone.
 */
@Component({
  selector: "lkt-view-switch",
  standalone: true,
  imports: [LktIconComponent],
  templateUrl: "./view-switch.component.html",
  styleUrl: "./view-switch.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LktViewSwitchComponent {
  public readonly segments = input<ViewSwitchSegment[]>([]);
  public readonly activeId = input<string>("");
  public readonly collapsed = input<boolean>(false);
  public readonly ariaLabel = input<string>("Alternar entre sistemas");
  public readonly dataCy = input<string>("view-switch");

  public readonly segmentClick = output<string>();

  public onSegment(id: string): void {
    if (id === this.activeId()) {
      return;
    }
    this.segmentClick.emit(id);
  }
}
